<template>
  <div class="page_content module_microCompetency" aria-label="Create Micro Competency">
    <div class="row page-heading">
      <div class="col-8 input module_heading">
        <span class="module_icon ic24-microCompetency"></span>
        <template v-if="operationState!=2">
          <h1 class="head_txt module_type_name ace_sec_hd" role="heading" aria-level="1">
            {{model.title}}
          </h1>
        </template>
        <template v-else>
          <b-form-input id="title" type="text"
            v-model.trim="model.title" :state="titleState"
            placeholder="Type in the Micro Competency title*"
            aria-label="type in the Micro Competency title"
            aria-describedby="titleFeedback" v-focus>
          </b-form-input>
          <b-form-invalid-feedback id="titleFeedback">
            Title must not be empty
          </b-form-invalid-feedback>
        </template>

      </div>
      <div class="btn-container col-4">
        <!-- Menu -->
        <div class="pg_3x3_menu">
          <b-dropdown no-caret class="navigation-menu" id="mcNavMenu">
            <template slot="button-content">
              <span id="mcNav" class="module_icon ic22-menu3x3">
                <span class="sr-only">menu</span>
              </span>
            </template>
            <div class="links new_menu">
                <b-dropdown-item class="lnk_menu lnk_menu_footer" @click="opstate=1" role="link" aria-label="About">
                  <span class="lnk_txt">About</span>
                </b-dropdown-item>
                <b-dropdown-item class="lnk_menu lnk_menu_footer" :disabled="(!uuid)" @click="player(false)" role="link" aria-label="Content">
                  <span class="lnk_txt">Content</span>
                </b-dropdown-item>
                <b-dropdown-item class="lnk_menu lnk_menu_footer" @click="opstate=3" role="link" aria-label="Logic">
                  <span class="lnk_txt">Progress/Performance</span>
                </b-dropdown-item>
                <b-dropdown-item class="lnk_menu lnk_menu_footer" role="link" aria-label="Logic" :disabled="(!uuid)" @click="makeCopy(uuid)" >
                  <span class="lnk_txt">Make a Copy</span>
                </b-dropdown-item>

            </div>
          </b-dropdown>
        </div>
        <!-- End Menu -->
        <template v-if="operationState==2">
          <button class="btn-cancel" @click="cancel">
          <span class="icon-cross"></span>
          </button>
          <button class="btn btn-primary" @click="done(true)">done</button>
          <button class="btn btn-primary" @click="save(false)">save</button>
        </template>
        <template v-if="operationState==3">
          <button class="btn btn-primary" @click="opstate=4">edit</button>
        </template>
        <template v-if="operationState==4">
          <button class="btn-cancel" @click="opstate=3">
          <span class="icon-cross"></span>
          </button>
          <button class="btn btn-primary" @click="done(true)">done</button>
          <button class="btn btn-primary" @click="save(false)">save</button>
        </template>
        <template v-if="operationState==1">
          <button class="btn btn-primary" @click="opstate=2">edit</button>
          <button :disabled="!isAdminLogin && (!uuid || model.published )" class="btn btn-primary" @click="curate(false)">curate</button>
        </template>
      </div>
    </div>
<!-- End Header -->

<!-- About -->
    <div class="row page-content" v-if="operationState==1">
      <div class="col-3 thumbnail_panel ace_sec" aria-label="Thumbnail Section">
        <div class="thumbnail_container d-flex ace_sec_txt">
          <div class="ic ic24-microCompetency"></div>
        </div>
        <div class="mb-4 py-3">
          <div class="page_section_row row pl-4 mb-2">
            <label for="folder" id="folderName" ace_sec_txt>Folder</label>
          </div>
          <div class="page_section_row row pl-4 mb-2">
            {{model.owningLibraryName}}
          </div>
        </div>
      </div>
      <div class="col-7 left-spacer ace_sec">
        <div class="page-section">
          <div class="page_section_row description min-content">
            <div class="heading">
              <label for="description" id="microCompetencyDescription" class="ace_sec_txt">Description</label>
            </div>
            <div class="value">
              <div class="courseDesc">
                <div class="course-desc-content ace_sec_txt">
                  <div class="custom_container_course_about">
                    <div v-html="model.description"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="page_section_row description min-content" v-if="model.code">
            <div class="heading">
              <label class="ace_sec_txt">Micro Competency Code</label>
            </div>
            <div class="value">
              <div class="courseDesc">
                <div class="course-desc-content ace_sec_txt">
                  <div class="custom_container_course_about">
                    <div v-html="model.code"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="page_section_row description min-content">
            <div class="heading">
              <label class="ace_sec_txt">Micro Competency Type</label>
            </div>
            <div class="value">
              <div class="courseDesc">
                <div class="course-desc-content ace_sec_txt">
                  <div class="custom_container_course_about">
                    <div v-html="getTypeLabel(model.competencyType)"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="page_section_row description min-content">
            <div class="heading">
              <label class="ace_sec_txt">Tags</label>
            </div>
            <div class="value page_content_block" style="float: left; margin-bottom: 10px; width: 97%;">
              <div class="">
                <div class="icon-container">
                  <span class="icon ic-tag"></span>
                </div>
                <div class="clo-container">
                  <div class="tag-list-section" v-if="isTagsAvailable()">
                    <div class="tag-box-list">
                      <div class="tag-list-length tags_container">
                        <template v-for="(values, key, i) in model.appliedTagMap">
                          <span class="tag ace_sec_txt" v-for="(tag, j) in values">
                          <span class="tag_name instructional_tag">{{tag.name}}</span>
                          </span>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <template>
              <add-tag-popup v-if="isShowTagPopup" :entity-data="taggingEntityData"></add-tag-popup>
            </template>
          </div>

          <div class="page_section_row description min-content">
            <div class="heading">
              <label class="ace_sec_txt">Pre-reqs</label>
            </div>
            <div class="value page_content_block" style="float: left; margin-bottom: 35px; width: 97%;">
              <div class="">
                <div class="clo-container">
                  <div class="tag-list-section">
                    <div class="tag-box-list">
                      <div class="tag-list-length tags_container">
                        <template v-for="prereq in model.preRequisites">
                          <span class="tag ace_sec_txt" >
                            <span class="tag_name instructional_tag">{{prereq.title}}</span>
                            </span>
                          </span>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
<!-- End About -->
<!-- Edit About -->
    <div class="row page-content" v-if="operationState==2">
      <div class="col-3 thumbnail_panel ace_sec" aria-label="Thumbnail Section">
        <div class="thumbnail_container d-flex ace_sec_txt">
          <div class="icon-photo"></div>
        </div>
        <div class="mb-4 py-3">
          <div class="page_section_row row pl-4 mb-2">
            <label for="folder" id="folderName" ace_sec_txt>Folder</label>
          </div>
          <div class="page_section_row row pl-4 mb-2">
            <select id="folder" v-model="model.owningLibraryId" aria-labelledby="folderName" style="width: 100%;">
              <option v-for="folder in folders" :value="folder.uuid">{{ folder.displayName }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-7 left-spacer ace_sec">
        <div class="page-section">

          <div class="row page_section_row description min-content">
            <div class="col-12 heading">
              <label for="description" id="microCompetencyDescription" class="ace_sec_txt">Description</label>
            </div>
            <div class="col-12 value" style="margin-bottom: 15px;">
              <editor
                v-model.trim="model.description"
                :init="({
                  base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
                  selector: 'textarea',
                  menubar: false,
                  plugins: plugins,
                  toolbar: toolbar,
                  branding: false,
                  statusbar: false,
                  end_container_on_empty_block: true
                })"
                @onInit="handlerInit"
                id="microCompetencyDescriptionId">
                </editor>
            </div>
          </div>
          <div class="row page_section_row description min-content" v-if="!uuid">
            <div class="col-12 heading">
              <label class="ace_sec_txt">Micro Competency Code</label>
            </div>
            <div class="col-12 page_content_block" style="margin-bottom: 15px;">
              <div class="row">

                <div class="col-6">
                  <div class="row fld_row">
                    <div class="col-3 fld_label pt-2">
                      Subject:
                    </div>
                    <div class="col-7 value fld_input">
                      <select id="folder" v-model="model.code1" aria-labelledby="folderName">
                        <option v-for="subject in subjects" :value="subject.subject">{{ subject.subject }}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <div class="row fld_row">
                    <div class="col-3 fld_label pt-2">
                      Topic:
                    </div>
                    <div class="col-7 value fld_input">
                      <select id="folder" v-model="model.code2" aria-labelledby="folderName">
                        <option v-for="module in filteredModules" :value="module.module">{{ module.module }}</option>
                      </select>
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>

          <div class="row page_section_row description min-content">
            <div class="col-12 heading">
              <label class="ace_sec_txt">Micro Competency Type</label>
            </div>
            <div class="col-12 value page_content_block" style="margin-bottom: 20px;">
              <select id="folder" v-model="model.competencyType" aria-labelledby="folderName" style="width: 92%;">
                <option v-for="type in competencyTypes" :value="type.id">{{ type.displayName }}</option>
              </select>
            </div>
          </div>

          <div class="row page_section_row description min-content">
            <div class="col-12 heading">
              <label class="ace_sec_txt">Tags</label>
            </div>
            <div class="col-12 value page_content_block" style="margin-bottom: 25px;">
              <div class="">
                <div class="icon-container">
                  <span class="icon ic-tag"></span>
                </div>
                <div class="clo-container">
                  <div class="tag-list-section" v-if="isTagsAvailable()">
                    <div class="tag-box-list">
                      <div class="tag-list-length tags_container">
                        <template v-for="(values, key, i) in model.appliedTagMap">
                          <span class="tag ace_sec_txt" v-for="(tag, j) in values">
                          <span class="tag_name instructional_tag">{{tag.name}}</span>
                          </span>
                        </template>
                      </div>
                    </div>
                  </div>
                  <div class="no-tags" v-else @click="showAddTagPopup($event)">
                    <div class="tag-box-list">
                      <span class="help-label ace_sec_txt">click to add tags</span>
                    </div>
                  </div>
                  <button type="button" title="edit tag" aria-label="edit tag" class="icon-edit" @click="showAddTagPopup($event)"></button>
                </div>
              </div>
            </div>
            <template>
              <add-tag-popup v-if="isShowTagPopup" :entity-data="taggingEntityData"></add-tag-popup>
            </template>
          </div>

          <div class="row page_section_row description min-content">
            <div class="col-12 heading">
              <label class="ace_sec_txt">Pre-reqs</label>
            </div>
            <div class="col-12 value page_content_block" style="margin-bottom: 35px;">
              <div class="">
                <div class="clo-container">
                  <div class="tag-list-section">
                    <div class="tag-box-list">
                      <div class="tag-list-length tags_container">
                        <template v-for="prereq in model.preRequisites">
                          <span class="tag ace_sec_txt" >
                            <span class="tag_name instructional_tag">{{prereq.title}}</span>
                            </span>
                          </span>
                        </template>

                      </div>
                    </div>
                  </div>
                  <button type="button" title="edit tag" aria-label="edit tag" class="icon-edit" @click="editPreReq()"></button>

                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
    </div>
<!-- End Edit About -->
<!--  Logic -->
    <div class="row page-content" v-if="operationState==3">
      <div class="col-7 left-spacer ace_sec">
        <div class="page-section">
          <div class="page_section_row description min-content">
            <div class="heading">
              <label for="Progress" class="ace_sec_txt">Progress</label>
            </div>
            <div class="value page_content_block ">
                  <div>
                   <label v-if="model.progressType=='PROGRESS_ALL_KC_CHILDREN_COMPLETED'">All KC completed
                   </label>
                   <label v-if="model.progressType=='PROGRESS_ANY_CHILD_SCORE_CUTOFF'">Any KC Completed with a mininimun of {{model.progressTypeCutoff}}
                   </label>
                   <label v-if="model.progressType=='PROGRESS_ALL_CHILDREN_COMPLETED'" >All children (resources etc) completed
                   </label>
                   <label v-if="model.progressType=='PROGRESS_MANUALLY_COMPLETED'" >manually marked completed
                   </label>
                </div>
            </div>
          </div>
          <div class="page_section_row description min-content">
            <div class="heading">
              <label for="Progress" class="ace_sec_txt">Performance</label>
            </div>
            <div class="value page_content_block ">
                <div>
                   <label v-if="model.performanceType=='PERFORMANCE_BEST'">Top KC Score
                   </label>
                   <label v-if="model.performanceType=='PERFORMANCE_AVERAGE'">Average of all KC scores
                   </label>
                   <label v-if="model.performanceType=='PERFORMANCE_LAST_KC'">Last KC Score
                   </label>
                   <label v-if="model.performanceType=='PERFORMANCE_WEIGHT'">Weightage of all KC scores
                   </label>

                </div>

            </div>
          </div>

        </div>
      </div>
    </div>
<!-- End  Logic -->
<!-- Edit Logic -->
    <div class="row page-content" v-if="operationState==4">
      <div class="col-10">
        <div class="page-section pg_fld_sec">
          <div class="page_section_row description min-content">
            <div class="heading">
              <label for="Progress" class="ace_sec_txt">Progress</label>
            </div>
            <div class="value page_content_block">
              <div class="row">
                <div class="col-6">
                  <div class="row fld_row">
                    <div class="col-1 fld_input fld_radio">
                      <input type="radio" name="progressType" id="one" value="PROGRESS_ALL_KC_CHILDREN_COMPLETED" v-model="model.progressType">
                    </div>
                    <div class="col-11">
                      <label>
                        All KC completed
                      </label>
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="row fld_row">
                    <div class="col-1 fld_input fld_radio">
                      <input type="radio" name="progressType" id="two" value="PROGRESS_ANY_CHILD_SCORE_CUTOFF" v-model="model.progressType">
                    </div>
                    <div class="col-11">
                       <label>
                         Any KC Completed with a mininimun of
                         <input type="text" name="progressTypeCutoff" size="2" style="width: 30px; margin-top: -5px;" v-model="model.progressTypeCutoff">
                       </label>
                     </div>
                   </div>
                 </div>
               </div>
               <div class="row mt-3">
                 <div class="col-6">
                   <div class="row fld_row">
                     <div class="col-1 fld_input fld_radio">
                       <input type="radio" name="progressType" id="three" value="PROGRESS_ALL_CHILDREN_COMPLETED" v-model="model.progressType">
                     </div>
                     <div class="col-11">
                       <label>
                         All children (resources etc) completed
                       </label>
                     </div>
                   </div>
                 </div>
                 <div class="col-6">
                   <div class="row fld_row">
                     <div class="col-1 fld_input fld_radio">
                       <input type="radio" name="progressType" id="foru" value="PROGRESS_MANUALLY_COMPLETED" v-model="model.progressType">
                     </div>
                     <div class="col-11">
                       <label>
                         Manually marked completed
                       </label>
                     </div>
                   </div>
                </div>
              </div>
            </div>
          </div>
          <div class="page_section_row description min-content">
            <div class="heading">
              <label for="Progress" class="ace_sec_txt">Performance</label>
            </div>
            <div class="value page_content_block">
                <div class="row">
                  <div class="col-6">
                    <div class="row">
                      <div class="col-1 fld_input fld_radio">
                        <input type="radio" name="performanceType" id="one" value="PERFORMANCE_BEST" v-model="model.performanceType">
                      </div>
                      <div class="col-11">
                        <label>
                          Top KC Score
                        </label>
                      </div>
                    </div>
                 </div>
                 <div class="col-6">
                   <div class="row">
                     <div class="col-1 fld_input fld_radio">
                       <input type="radio" name="performanceType" id="two" value="PERFORMANCE_AVERAGE" v-model="model.performanceType">
                     </div>
                     <div class="col-11">
                       <label>
                         Average of all KC scores
                       </label>
                     </div>
                   </div>
                 </div>
               </div>
               <div class="row mt-3">
                 <div class="col-6">
                   <div class="row">
                     <div class="col-1 fld_input fld_radio">
                       <input type="radio" name="performanceType" id="three" value="PERFORMANCE_LAST_KC" v-model="model.performanceType">
                    </div>
                    <div class="col-11">
                     <label>
                       Last KC Score
                     </label>
                    </div>
                   </div>
                 </div>
                 <div class="col-6">
                   <div class="row">
                     <div class="col-1 fld_input fld_radio">
                       <input type="radio" name="performanceType" id="foru" value="PERFORMANCE_WEIGHT" v-model="model.performanceType">
                     </div>
                     <div class="col-11">
                       <label>
                         Weightage of all KC scores
                       </label>
                     </div>
                   </div>
                 </div>
               </div>
            </div>
          </div>

        </div>
      </div>
    </div>
<!-- End Edit Logic -->

    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF">
          <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
        </div>
      </b-modal>
    </div>
    <div>
        <b-modal class="delete-item-popup" ref="updateCopiesModal" :title="model.title" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
            <div>
                <span>Master of this Micro Competency updated successfully.</span>
                <br/><br/>
            </div>
            <div>
                <span>Do you want to update ALL copies of this Micro Competency?</span>
            </div>
            <div slot="modal-header" class="popover-header">
              <div class="popup-heading">{{model.title}}</div>
              <button class="btn_close" aria-label="close" @click="closeUpdateCopiesModal">
                   <span class="ic-close"></span>
              </button>
            </div>
            <div slot="modal-footer" class="w-100">
                <b-button @click="updateCopies" class="btn button-primary float-right mr-2"> yes </b-button>
                <b-button @click="closeUpdateCopiesModal" class="btn button-primary float-right mr-2"> no </b-button>
            </div>
        </b-modal>
    </div>

    <div>
      <data-loss-prompt ref="dataLossAlert" @okLose="okLose" @saveAndContinue="saveAndContinue"></data-loss-prompt>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import DataLossPrompt from '../../common/components/DataLossPrompt'
import AddTagPopup from '../../tagging/components/AddTagPopup'
import _ from 'lodash'
import { mapState, mapActions } from 'vuex'
import Editor from '@tinymce/tinymce-vue'
import { StorageFactory } from '../../../storageFactory'

export const localStore = StorageFactory(() => localStorage)

Vue.directive('focus', {
  inserted (el) {
    el.focus()
  }
})


export default {
  name: 'microCompetency-create',
  props: ['opstate', 'uuid'],
  components: {
    DataLossPrompt,
    Editor,
    AddTagPopup
  },
  data: () => {
    return {
      plugins: 'charmap code hr link searchreplace textcolor autoresize media image imagetools table lists',
      toolbar: 'undo redo  bold italic underline bullist numlist outdent indent link unlink alignleft aligncenter alignright alignjustify media insertfile image table forecolor backcolor | searchreplace removeformat | fontselect fontsizeselect styleselect',
      model: {
        microCompetency: true,
        title: 'Untitled Micro Competency',
        description: undefined,
        owningLibraryId: undefined,
        appliedTagMap: {},
        competencyType: 'CBL',
        code: undefined,
        code1: 'MATH',
        code2: 'ALGEBRA',
        progressType: "PROGRESS_ALL_CHILDREN_COMPLETED",
        performanceType: "PERFORMANCE_BEST",
        progressTypeCutoff: 80,
        published: true,
        preRequisites:[]

      },
      competencyTypes : [{id:'PBL', displayName:"Problem Based Learning"},{id:'CBL', displayName:"Competency Based Learning"}],
      subjects: [],
      modules: [],
      folders : [],
      copies : [],
      isDoneClicked: false,
      isShowTagPopup: false,
      allSelected:false,
      selectedResult : [],
      sizeOptions: [ 10, 50, 100 ],
      terms: undefined
    }
  },

  mounted () {
    if(!this.opstate){
        this.opstate = 1
    }
    this.loadPermission().then(res => {
      if(this.uuid){
          this.loadMicroCompetency(this.uuid)
      }
      this.populateLibrary()
      this.loadMicroCompetencySubjects().then(res => {
          this.subjects = res
      })
      this.loadMicroCompetencyModules().then(res => {
          this.modules = res
      })
    })
  },

  beforeRouteLeave (to, from, next) {
    if (this.dirty) {
      this.nextPage = next
      this.$refs.dataLossAlert.showPrompt()
      next(false)
    } else {
      next()
    }
  },

  computed: {
    ...mapState({
      'permission': state => state.user.permission,
      'results': state => state.search.results,
      'total': state => state.search.total,
      'facetResults': state => state.search.aggregations,
      'from': state => state.search.from,
      'pageNumber': state => state.search.pageNumber,
      'size': state => state.search.size,
      'sort': state => state.search.sort,
      'userObj': state => state.user.userObj

    }),

    titleState () {
      return this.model.title.length > 0
    },
    operationState () {
        return this.opstate
    },
    isAdminLogin () {
      return (localStorage.getItem('userrole') === 'Instructor & Admin')
    },

    filteredModules (){
      let filterData = []
      $.each(this.modules, (index, module) => {
          if (module.subject === this.model.code1) {
            filterData.push(module)
          }
      })
      if(filterData[0]){
        this.model.code2 = filterData[0].module
      }
      return filterData
    },
    dragOptions () {
      return {
        animation: 0,
        group: 'content',
        disabled: false,
        ghostClass: 'ghost'
      }
    }

  },

  methods: {
    ...mapActions([
      'loadLibrariesForUser',
      'createMicroCompetency',
      'loadMicroCompetencyDetail',
      'loadMicroCompetencySubjects',
      'loadMicroCompetencyModules',
      'loadCopyCourseDetail',
      'saveCourseDetail',
      'loadCourseDetail',
      'loadMicroCompetencies',
      'loadCourseTopics',
      'deleteCourseDetail',
      'loadPLOForInstitution',
      'addCompetencyTreeToCourse',
      'loadPermission',
      'updateMicroCompetencyChildren',
      'createCopy'
    ]),

    handlerInit (ev, editor) {
      $('#microCompetencyDescriptionId_ifr').css({width: '100%', height: '250px', border: '1px solid #ccc'})
    },
    populateLibrary () {
      const userId = localStorage.getItem('userid')
      this.loadLibrariesForUser(userId).then(learningSpaces => {
        this.folders = []
        if(!this.model.owningLibraryId){
          this.model.owningLibraryId = learningSpaces[0].uuid
        }
        for (var i = 0; i < learningSpaces.length; i++) {
          const learningSpace = learningSpaces[i]
          const permission = learningSpace.acelist[0].permission
          if (permission && permission.folderPermission && permission.folderPermission.allowedAsDestinationFolder) {
            this.folders.push(learningSpace)
            if (learningSpace.category === 'Institute_Public' && !this.model.owningLibraryId) {
              this.model.owningLibraryId = learningSpace.uuid
            }
          }
        }
        if(!this.uuid){
          this.$data.oldModel = _.cloneDeep(this.$data.model)
        }

      })
    },
    loadMicroCompetency (uuid){
        this.loadMicroCompetencyDetail(uuid).then((res) => {
          this.copies = res.copies
          this.model.title = res.title
          this.model.description = res.description
          this.model.appliedTagMap = res.appliedTagMap
          this.model.owningLibraryId = res.owningLibraryId
          this.model.owningLibraryName = res.owningLibraryName
          this.model.competencyType = res.competencyType
          this.model.code = res.code
          this.model.progressType = res.progressType
          this.model.performanceType = res.performanceType
          this.model.progressTypeCutoff = res.progressTypeCutoff
          this.model.preRequisites = res.preRequisites
          this.model.published = res.published
          this.$data.oldModel = _.cloneDeep(this.$data.model)
        })

    },
    save (goNext){ 
      if (!this.titleState) {
          return
      }
        this.dirty = false
        this.$refs.loadingModal.show()
        var data = {
          uuid: this.uuid,
          microCompetency: true,
          title: this.model.title,
          description: this.model.description,
          appliedTagMap: this.model.appliedTagMap,
          owningLibraryId: this.model.owningLibraryId,
          competencyType: this.model.competencyType,
          progressType: this.model.progressType,
          performanceType: this.model.performanceType,
          progressTypeCutoff: this.model.progressTypeCutoff,
        }
        if(!this.uuid){
          data.code = this.model.code1+'.'+this.model.code2
        }
        this.createMicroCompetency(data).then((res) => {
          if (res.uuid) {
            this.uuid = res.uuid
            this.model.code = res.code
            this.$data.oldModel = _.cloneDeep(this.$data.model)
            this.showMessage(' created successfully.')
          }
          this.$refs.loadingModal.hide()
          if(this.copies && this.copies.length>0){
              this.isDoneClicked = goNext
              this.showUpdateCopiesModal()
          }else{
            if (goNext) {
              if (this.nextPage) {
                this.$emit('resolveNext', this.nextPage)
              }else{
                  this.opstate=1
              }
            }
          }
        })
    },
    updateCopies (){ 
        this.$refs.updateCopiesModal.hide()
        this.updateMicroCompetencyChildren(this.uuid).then((res) => {
          this.showMessage(' copies updated successfully.')
          if (this.isDoneClicked) {
            this.isDoneClicked = false
            if (this.nextPage) {
              this.$emit('resolveNext', this.nextPage)
            }else{
                this.opstate=1
            }
          }
        })
    },    
    showMessage (message) {
      this.$notify({
        group: 'notify',
        type: 'success',
        title: '',
        text: 'Micro Competency : "' + this.model.title + '"' + message
      })
    },
    closeUpdateCopiesModal () {
      this.isDoneClicked = false
      this.$refs.updateCopiesModal.hide()
    },
    showUpdateCopiesModal () {
      this.$refs.updateCopiesModal.show()
    },
    makeCopy(mcId){
        this.createCopy(mcId).then(res => {
          if(res.uuid){
            setTimeout(() => {
              return this.$router.push({ name: 'microCompetencyList' })
            }, 1000)
            this.showMessage('Successfully created copy of '+res.title)
          }else{
            this.showMessage('Error created copy of '+this.model.title)
          }
        })
    },

    curate (){
      return this.$router.push({ name: 'microCompetencyCurate', params: { uuid: this.uuid } })
    },
    editPreReq (){
      return this.$router.push({ name: 'microCompetencyPreReq', params: { uuid: this.uuid } })
      },
    player (){
      return this.$router.push({ name: 'microCompetencyPlayer', params: { uuid: this.uuid } })
    },
    done (isDone) {
        this.save(isDone);
    },
    cancel () {
      this.opstate = 1
    },
    onMove (ev) {
      if (ev.draggedContext.element.action === undefined || ev.draggedContext.element.action !== 'COPY') {
        ev.draggedContext.element.action = 'MOVE'
      }
    },
    showEllipsisTags () {
      var tagListLength = $('.tag-list-length').height()
      if (tagListLength > 34) {
        $('.ellipsisTags').show()
      } else {
        $('.ellipsisTags').hide()
      }
    },
    getTypeLabel(type){
      for(var j=0;j<this.competencyTypes.length;j++){
          if(type===this.competencyTypes[j].id){
            return this.competencyTypes[j].displayName
          }
      }
    },
    isTagsAvailable () {
      if(this.model.appliedTagMap){
        let values = Object.values(this.model.appliedTagMap)
        return values.find((value) => {
          return value.length > 0
        })
      }else{
        false
      }
    },

    showAddTagPopup (event) {
      this.isShowTagPopup = true
      this.taggingEntityData = {title: this.model.title, type: 'topics', appliedTagMap: this.model.appliedTagMap}
      setTimeout(() => {
        this.$root.$emit('bv::show::modal', 'addTagPopup', event.target)
      }, 500)
    },




    returnToDashboard () {
      let userPermission = this.permission.userPermission
      if (userPermission.studentHomeView) {
        return this.$router.push({ name: 'studentDashboard' })
      } else if (userPermission.employerAdminHomeView) {
        return this.$router.push({ name: 'employerAdmin' })
      } else if (userPermission.advisorHomeView) {
        return this.$router.push({ name: 'advisorDashboard' })
      } else if (userPermission.instructorHomeView) {
        if (userPermission.adminHomeView) {
          let name = (this.isNuNavLogin) ? 'nunavAdminDashboard' : 'adminDashboard'
          return this.$router.push({ name: name })
        } else {
          return this.$router.push({ name: 'instructorDashboard' })
        }
      }
    },

    createCourseWithCompetencyTree () {
      this.$refs.createCourseCompetencyTreeModal.hide()
      this.$refs.loadingModal.show()
      this.addCompetencyTreeToCourse({microCompetencyId: this.microCompetencyId, competencyId: this.selectedCompetencyId}).then(res => {
        setTimeout(() => {
          this.showMessageAndRedirect(' created successfully.')
        }, 1000)
      })
    },

    createCourseWithoutCompetencyTree () {
      this.$refs.createCourseNoCompetencyTreeWarningModal.hide()
      this.$refs.loadingModal.show()
      setTimeout(() => {
        this.showMessageAndRedirect(' created successfully.')
      }, 1000)
    },

    doNotCreateCourseWithoutCompetencyTree () {
      this.$refs.createCourseNoCompetencyTreeWarningModal.hide()
      this.$refs.loadingModal.show()
      this.deleteCourseDetail(this.microCompetencyId).then(res => {
        setTimeout(() => {
          this.returnToDashboard()
        }, 1000)
      })
    },

    competencyPopover () {
      $('.clo-box').mouseover(function () {
        $('body').addClass('competency-popover')
      })
    },

    closeCompetencyPopover () {
      $('.clo-box').mouseleave(function () {
        $('body').removeClass('competency-popover')
      })
    },

    expandCollapseClo () {
      if ($('.clo').hasClass('clo-content')) {
        $('.clo').toggleClass('expandClo', 500)
      }
    },

    okLose () {
      this.$emit('resolveNext', this.nextPage)
    },

    saveAndContinue () {
      this.save(true)
    }
  },

  watch: {
    model: {
      handler () {
        this.dirty = !_.isEqual(this.$data.model, this.$data.oldModel)
      },
      deep: true
    }

  }
}
</script>

<style>

    a.disabled {
        color: #dcdad1 !important;
        pointer-events: none;
    }

    .header-section {
        width: 100%;
    }


</style>



// WEBPACK FOOTER //
// src/app/microCompetency/components/MicroCompetencyCreate.vue